@use '@css/variables';

.container {

  position: fixed;
  top: 100%;
  width: 100%;
  height: 0;
  left: 0;
  z-index: 220;

  .actions {
    position: absolute;
    bottom: -380px;
    left: 0;
    right: 0;
    border-radius: var(--border-radius);
    background-color: white;
    padding: 15px;

    transition: 0.3s;
    z-index: 10;


    .btn {
      cursor: pointer;
    }
    .btn.commercial
    {
      display: none;
    }

    &.open {
      bottom: 0px;
      //top: auto;

      &.hideInteractions {
      }
    }


    & > div {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }



    .btn {
      display: flex;
      background-color: var(--beige);
      color: black;
      border-radius: var(--border-radius);
      padding: .65em 1.5em;

      align-items: center;
      gap: 1em;

      & > span
      {
        flex-grow: 1;
        text-align: left;
      }

      strong {
        font-weight: normal;
      }

      & > i { // right arrow
        display: none;
      }
    }

    .btnDark {
      background-color: var(--beigedarker);
      color: white;
    }

    .btnLink {
      background-color: transparent;
      color: black;
    }


  }

  .toggle {
    position: fixed;
    left: .75em;
    right: .75em;
    bottom: .75em;
    border-radius: var(--border-radius);
    padding: .75em;
    background-color: var(--beigedarker);
    color: white;
    cursor: pointer;

    transition: right .25s;

    // Add extra space for UpButton
    :global(body.up-button) &
    {
      right: 4.5em;
    }
  }

}
@media only screen and (min-width: variables.$md-breakpoint) {

  .container {
    //position: relative;
    position: sticky;
    height: auto;
    top: 115px;
    width: auto;

    .wrapper {
      display: flex;
      flex-direction: row;

    }

    .actions {

      position: relative;
      background-color: transparent;
      //flex-shrink: 0;
      //flex-basis: 320px;
      width: 320px;
      padding: 0;
      bottom: auto;
      top: 0;

      & > div {

        .btn {
          background-color: white;
          color: black;

          strong {
            font-weight: bold;
          }

          & > i { // right arrow
            display: block;
            color: var(--beigedarker);
          }
        }
      }

      .commercial
      {
        display: block !important;
        padding: 10px;
      }
    }

    .toggle {
      display: none;
    }
  }
}
